module.exports = __webpack_public_path__ + "img/millfields_rd_b6.bad0b449.jpg";